import { styled } from '@mui/material/styles'
import InputLabelMui from '@mui/material/InputLabel'
import OutlinedInputMui from '@mui/material/OutlinedInput'
import FormControlMui from '@mui/material/FormControl'
import FormHelperTextMui from '@mui/material/FormHelperText'

export const FieldContainer = styled(FormControlMui)({})

export const Label = styled(InputLabelMui)({
  fontWeight: '500',
  fontSize: '12px',
  lineHeight: '18px',
})

export const Input = styled(OutlinedInputMui)({
  height: '42px',
  fontSize: '14px',
})

export const HelperText = styled(FormHelperTextMui)({})
